import { render, staticRenderFns } from "./ApplicationDocuments.vue?vue&type=template&id=2e437516&scoped=true&"
import script from "./ApplicationDocuments.vue?vue&type=script&lang=js&"
export * from "./ApplicationDocuments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.10.0_babel-co_0dbbf42f62185882c0604707ed980ddd/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e437516",
  null
  
)

export default component.exports